import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const PageShell = ({ children }) => {
  const { user, logout } = useAuth();
  return (
    <div style={{ minHeight: '100vh', background: '#0A0A0A', color: '#F5F5F0' }}>
      <header
        className="fixed top-0 left-0 right-0 z-50"
        style={{ background: 'rgba(10,10,10,0.9)', backdropFilter: 'blur(14px)', borderBottom: '1px solid rgba(201,168,76,0.18)' }}
      >
        <nav className="mx-auto max-w-[1100px] px-5 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="shell-home-link">
            <span className="flex items-center justify-center" style={{ width: '34px', height: '34px', background: '#C8282B', borderRadius: '8px' }}>
              <span className="text-white font-bold" style={{ fontSize: '18px' }}>山</span>
            </span>
            <span className="font-display text-white" style={{ fontSize: '20px', fontWeight: 700 }}>Yamauchi</span>
          </Link>
          <div className="flex items-center gap-4">
            {user && user.role === 'admin' && (
              <Link to="/admin" className="font-body uppercase text-[11px]" style={{ letterSpacing: '1.5px', color: '#C9A84C' }} data-testid="shell-admin-link">
                Admin
              </Link>
            )}
            {user ? (
              <>
                <Link to="/mis-pedidos" className="font-body uppercase text-[11px]" style={{ letterSpacing: '1.5px', color: '#C2C1B6' }} data-testid="shell-orders-link">
                  Mis Pedidos
                </Link>
                <button
                  onClick={logout}
                  className="font-body uppercase text-[11px]"
                  style={{ letterSpacing: '1.5px', color: '#C2C1B6' }}
                  data-testid="shell-logout"
                >
                  Salir
                </button>
              </>
            ) : (
              <Link to="/login" className="font-body uppercase text-[11px] px-3 py-1.5 border" style={{ letterSpacing: '1px', color: '#C9A84C', borderColor: 'rgba(201,168,76,0.45)' }} data-testid="shell-login-link">
                Entrar
              </Link>
            )}
          </div>
        </nav>
      </header>
      <main className="pt-24 pb-20 px-5">
        <div className="mx-auto max-w-[1100px]">{children}</div>
      </main>
    </div>
  );
};

export const goldButton = {
  border: '1px solid #C9A84C', color: '#C9A84C', padding: '13px 28px',
  fontSize: '12px', letterSpacing: '2px', fontWeight: 600, textTransform: 'uppercase',
  background: 'transparent', cursor: 'pointer', transition: 'all 0.2s ease',
};

export const redButton = {
  background: '#C8282B', color: '#fff', padding: '14px 30px',
  fontSize: '12px', letterSpacing: '2px', fontWeight: 600, textTransform: 'uppercase',
  border: 'none', cursor: 'pointer', transition: 'background-color 0.2s ease',
};
